import { render, staticRenderFns } from "./BCXBreadcrumbs.vue?vue&type=template&id=7f5bfd98"
import script from "./BCXBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./BCXBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./BCXBreadcrumbs.vue?vue&type=style&index=0&id=7f5bfd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports